import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const OFFICIAL_TITLES_LIST = "official_titles_list";
export const CREATE_OFFICIAL_TITLES = "create_official_titles";
export const UPDATE_OFFICIAL_TITLES = "update_official_titles";
export const DELETE_OFFICIAL_TITLES = "delete_official_titles";
export const GET_OFFICIAL_TITLES_DETAILS = "get_official_titles_details";
export const OFFICIAL_TITLES_SIMPLE_LIST = "official_titles_simple_details";
export const CLEAR_OFFICIAL_TITLES_ERRORS = "clearOfficialTitlesErrors";

// mutation types
export const SET_OFFICIAL_TITLES_ERROR = "setOfficialTitlesError";
export const REMOVE_OFFICIAL_TITLES_ERRORS = "removeOfficialTitlesErrors";

const state = {
    errors: null
};
const actions = {
    [OFFICIAL_TITLES_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.simpledatatable("api/officialtitles?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_OFFICIAL_TITLES_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_OFFICIAL_TITLES_ERROR, response.errors);
                });
        });
    },
    [CREATE_OFFICIAL_TITLES](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createofficialtitle", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_OFFICIAL_TITLES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_OFFICIAL_TITLES_ERROR, response.errors);
                });
        });
    },
    [UPDATE_OFFICIAL_TITLES](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updateofficialtitle", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_OFFICIAL_TITLES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_OFFICIAL_TITLES_ERROR, response.errors);
                });
        });
    },
    [DELETE_OFFICIAL_TITLES](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deleteofficialtitle", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_OFFICIAL_TITLES_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_OFFICIAL_TITLES_ERROR, response.errors);
                });
        });
    },
    [GET_OFFICIAL_TITLES_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getofficialtitledetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_OFFICIAL_TITLES_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_OFFICIAL_TITLES_ERROR, response.errors);
                });
        });
    },
    [CLEAR_OFFICIAL_TITLES_ERRORS](context) {
        context.commit(REMOVE_OFFICIAL_TITLES_ERRORS);
    },
    [OFFICIAL_TITLES_SIMPLE_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/officialtitlessimple?type=" + payload.type)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                }).catch(({response}) => {
                context.commit(SET_OFFICIAL_TITLES_ERROR, response.errors);
            });
        });
    },
};

const mutations = {
    [SET_OFFICIAL_TITLES_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_OFFICIAL_TITLES_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
